import { memo, useCallback } from "react";
import { SelectPicker } from "../../../components";
import {IoHomeSharp, IoPersonSharp, IoPeopleSharp, IoClipboardSharp } from "react-icons/io5";

function StaffSelector({ subordinates, selectedEmail, isLoading, onSelect }) {
  // Staff can arrive flat or grouped under an area manager; group the picker
  // only when the data actually carries an area manager name.
  const isGrouped = subordinates.some((staff) => staff.areaManagerName);
  const data = subordinates.map((staff) => ({
    label: staff.employeeName,
    value: staff.employeeEmail,
    costCentreName: staff.costCentreName,
    goalCount: staff.goalCount,
    areaManagerName: staff.areaManagerName,
    isAreaManager: staff.isAreaManager,
  }));

  const filterOption = useCallback((option, rawInput) => {
    const words = rawInput.split(" ").map((word) => word.toLowerCase());
    const name = (option.data.label || "").toLowerCase();
    const centre = (option.data.costCentreName || "").toLowerCase();
    const manager = (option.data.areaManagerName || "").toLowerCase();
    return words.every((word) => name.includes(word) || centre.includes(word) || manager.includes(word));
  }, []);

  const getOptionLabel = useCallback((option) => {
    if (!option) return null;
    return (
      <div className={`staff-selector-item ${option.isAreaManager ? "is-area-manager" : ""}`}>
        <span className="staff-selector-item-name">
          {option.isAreaManager ? <IoPeopleSharp /> : <IoPersonSharp />} {option.label}
        </span>
        <span className="staff-selector-item-centre"><IoHomeSharp /> {option.costCentreName}</span>
        <span className={`staff-selector-item-goals ${option.goalCount > 0 ? "has-goals" : "no-goals"}`}>
          <IoClipboardSharp /> {option.goalCount > 0 ? `${option.goalCount} focus note${option.goalCount > 1 ? "s" : ""}` : "No focus notes"}
        </span>
      </div>
    );
  }, []);

  const handleChange = useCallback((option) => {
    onSelect(option?.value ?? null);
  }, [onSelect]);

  return (
    <section className="staff-selector-section" aria-label="Staff member selection">
      <h4 className="scorecard-history-title">
        <IoPeopleSharp className="scorecard-history-icon" /> My Team
      </h4>
      <p className="staff-selector-subtitle">Select a staff member to view their scorecard history</p>
      <SelectPicker
        data={data}
        value={selectedEmail}
        onChange={handleChange}
        loading={isLoading}
        placeholder="Search by name or centre..."
        className="staff-selector-picker"
        filterOption={filterOption}
        getOptionLabel={getOptionLabel}
        groupBy={isGrouped ? "areaManagerName" : undefined}
      />
    </section>
  );
}

export default memo(StaffSelector);
